export interface ProjectCapabilities {
  can_read: boolean;
  can_read_sensitive: boolean;
  can_save_draft: boolean;
  can_request_validation: boolean;
  can_validate: boolean;
  can_reject: boolean;
  can_download: boolean;
}

export interface SystemCapabilities {
  can_list_all_projects: boolean;
  can_download: boolean;
  can_read_users: boolean;
  can_manage_user_roles: boolean;
  can_save_any_project: boolean;
  can_validate_any_project: boolean;
  can_read_sensitive_projects: boolean;
}

export const EMPTY_PROJECT_CAPABILITIES: ProjectCapabilities = {
  can_read: false,
  can_read_sensitive: false,
  can_save_draft: false,
  can_request_validation: false,
  can_validate: false,
  can_reject: false,
  can_download: false,
};

export const EMPTY_SYSTEM_CAPABILITIES: SystemCapabilities = {
  can_list_all_projects: false,
  can_download: false,
  can_read_users: false,
  can_manage_user_roles: false,
  can_save_any_project: false,
  can_validate_any_project: false,
  can_read_sensitive_projects: false,
};

export const DEFAULT_PROJECT_MODE = 'viewer' as const;
